var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 120,
    viewBox: "0 0 109 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7050_15569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1282 117.122C19.8076 117.122 1.71397 96.0702 1.71397 70.0996C1.71397 44.1289 19.8076 23.0771 42.1282 23.0771H56.0825V117.122H42.1282Z",
    fill: "url(#paint0_linear_7050_15569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3887 12.6721V25.3446C44.3887 25.3446 51.6957 30.0696 59.0027 25.3446V12.1006L44.3887 12.6721Z",
    fill: "#51518E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7169 36.1655L13.5986 41.0663C14.0989 41.5688 14.7466 41.8972 15.4466 42.0033C16.1465 42.1094 16.862 41.9877 17.4879 41.656C19.2751 40.7393 20.7395 39.2952 21.684 37.5181C21.9976 36.8961 22.1062 36.1902 21.9941 35.5022C21.882 34.8143 21.555 34.1799 21.0603 33.6905L15.8358 28.4482L8.7169 36.1655Z",
    fill: "#51518E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1666 9.96724C35.1666 15.4707 42.6618 19.9319 51.9071 19.9319C61.1524 19.9319 68.6605 15.4707 68.6605 9.96724C68.6605 8.1569 67.846 6.45 66.4207 4.98362C63.5133 2.00431 58.1033 0 51.9071 0C45.7109 0 40.3086 2.00431 37.4064 4.98362C35.9811 6.45 35.1666 8.15172 35.1666 9.96724Z",
    fill: "url(#paint1_linear_7050_15569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4064 4.98362C40.3009 7.96293 45.7109 9.96724 51.9071 9.96724C58.1032 9.96724 63.5056 7.96293 66.4103 4.98362C63.5133 2.00431 58.1032 0 51.9071 0C45.7109 0 40.3009 2.00431 37.4064 4.98362Z",
    fill: "#A175FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.43323e-05 34.4176C-3.43323e-05 35.9279 0.443283 37.2443 1.38147 38.1857C4.16253 40.9736 10.2144 39.4244 14.9002 34.7227C19.5859 30.021 21.1298 23.9486 18.3513 21.1607C17.4673 20.2736 16.2533 19.8262 14.8589 19.777C11.8639 19.671 8.03127 21.4115 4.83267 24.621C1.72685 27.7374 0.0025444 31.4538 -3.43323e-05 34.4176Z",
    fill: "url(#paint2_linear_7050_15569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.90735e-06 34.4176C2.99499 34.5236 6.82764 32.7831 10.0262 29.5736C13.1192 26.4701 14.8564 22.7408 14.8589 19.777C11.864 19.671 8.03131 21.4115 4.8327 24.621C1.72688 27.7374 0.00257587 31.4538 -1.90735e-06 34.4176Z",
    fill: "#A175FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0825 117.122C32.6919 117.122 13.73 96.0693 13.73 70.0996C13.73 44.1298 32.6919 23.0771 56.0825 23.0771C79.4732 23.0771 98.4351 44.1298 98.4351 70.0996C98.4351 96.0693 79.4732 117.122 56.0825 117.122Z",
    fill: "#B897FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0825 107.897C37.2812 107.897 22.0397 90.9741 22.0397 70.0992C22.0397 49.2242 37.2812 32.3018 56.0825 32.3018C74.8839 32.3018 90.1254 49.2242 90.1254 70.0992C90.1254 90.9741 74.8839 107.897 56.0825 107.897Z",
    fill: "#FCF4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.639 46.2102C54.6881 34.1455 60.6807 36.7085 61.6395 65.136H50.5719C50.8764 58.7911 51.5667 52.4707 52.639 46.2102Z",
    fill: "#C5C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9614 79.6374C50.7116 79.6374 46.4558 75.3671 46.4558 70.0995C46.4558 64.8318 50.7116 60.5615 55.9614 60.5615C61.2112 60.5615 65.467 64.8318 65.467 70.0995C65.467 75.3671 61.2112 79.6374 55.9614 79.6374Z",
    fill: "url(#paint3_linear_7050_15569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6938 98.5758C61.7916 106.88 67.0289 110.426 69.9363 111.706C71.0157 112.183 71.8661 113.065 72.305 114.163C75.3154 121.663 81.7977 120.225 84.8159 119.059C85.85 118.658 86.9958 118.658 88.0299 119.059C91.0481 120.225 97.5278 121.66 100.541 114.163C100.978 113.064 101.828 112.182 102.907 111.706C105.814 110.431 111.062 106.88 108.152 98.5758C107.819 97.6214 107.819 96.582 108.152 95.6275C111.062 87.3232 105.814 83.7775 102.907 82.4999C101.827 82.0229 100.978 81.1397 100.541 80.0405C97.5278 72.5405 91.0481 73.981 88.0299 75.1474C86.9958 75.5483 85.85 75.5483 84.8159 75.1474C81.7977 73.981 75.3154 72.5456 72.305 80.0405C71.8662 81.1394 71.0159 82.0223 69.9363 82.4999C67.0289 83.7801 61.7916 87.3258 64.6938 95.6301C65.0258 96.5838 65.0258 97.6222 64.6938 98.5758Z",
    fill: "#F96767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5445 89.2017C78.898 88.8056 79.3937 88.5666 79.9228 88.5372C80.4519 88.5079 80.9709 88.6906 81.3657 89.0452L95.7837 101.977C95.9795 102.152 96.1389 102.365 96.2529 102.602C96.3668 102.84 96.433 103.097 96.4476 103.36C96.4623 103.623 96.4251 103.887 96.3382 104.135C96.2514 104.384 96.1165 104.613 95.9414 104.809C95.8423 104.919 95.7312 105.017 95.6104 105.101C95.2409 105.367 94.7923 105.499 94.3384 105.474C93.8844 105.45 93.4523 105.271 93.1132 104.968L78.7022 92.0343C78.5064 91.8587 78.3469 91.6462 78.233 91.4088C78.1191 91.1714 78.0529 90.9138 78.0382 90.6508C78.0236 90.3877 78.0608 90.1243 78.1476 89.8757C78.2345 89.627 78.3694 89.398 78.5445 89.2017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9588 105.554C78.8214 103.967 79.0661 101.839 80.5054 100.8C81.9446 99.7615 84.0334 100.206 85.1709 101.793C86.3083 103.38 86.0636 105.508 84.6243 106.547C83.1851 107.585 81.0963 107.141 79.9588 105.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1256 92.6351C87.9882 91.0483 88.2329 88.9199 89.6721 87.8812C91.1114 86.8425 93.2002 87.287 94.3376 88.8738C95.475 90.4607 95.2303 92.5891 93.7911 93.6277C92.3518 94.6664 90.263 94.222 89.1256 92.6351Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7050_15569",
    x1: 28.8982,
    y1: 23.0771,
    x2: -7.20426,
    y2: 135.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7050_15569",
    x1: 51.9135,
    y1: 1.44919e-7,
    x2: 49.0466,
    y2: 26.0576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7050_15569",
    x1: 9.86644,
    y1: 19.7725,
    x2: 5.16831,
    y2: 45.0987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7050_15569",
    x1: 55.9614,
    y1: 60.5615,
    x2: 51.4348,
    y2: 84.9622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7050_15569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 120,
    fill: "white",
    transform: "matrix(-1 0 0 1 109 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a5915e939867175d93477d02fc3f989e.svg";
export { ForwardRef as ReactComponent };